function getYouTubeEmbed(url) {
  try {
    const parsed = new URL(url)
    const host = parsed.hostname.replace(/^www\./, "")
    const isYouTubeHost = host === "youtu.be" || host === "youtube.com" || host.endsWith(".youtube.com")
    if (!isYouTubeHost) return null

    const playlistId = parsed.searchParams.get("list")
    const videoId = getYouTubeVideoId(parsed, host)

    if (videoId) {
      const embedUrl = new URL(`https://www.youtube.com/embed/${videoId}`)
      if (playlistId) embedUrl.searchParams.set("list", playlistId)
      return { src: embedUrl.toString(), title: "YouTube video" }
    }

    if (playlistId) {
      const embedUrl = new URL("https://www.youtube.com/embed/videoseries")
      embedUrl.searchParams.set("list", playlistId)
      return { src: embedUrl.toString(), title: "YouTube playlist" }
    }
  } catch {
    return null
  }

  return null
}

function getYouTubeVideoId(parsed, host) {
  if (host === "youtu.be") return parsed.pathname.split("/").filter(Boolean)[0]
  if (parsed.pathname === "/watch") return parsed.searchParams.get("v")

  const match = parsed.pathname.match(/^\/(?:embed|shorts)\/([^/?]+)/)
  return match?.[1] || null
}

function getSpotifyEmbed(url) {
  // Convert open.spotify.com/track/ID to embed URL
  const m = url.match(/open\.spotify\.com\/(track|album|playlist|episode|show)\/([^?]+)/)
  if (!m) return null
  return `https://open.spotify.com/embed/${m[1]}/${m[2]}?utm_source=generator&theme=0`
}

function getAppleMusicEmbed(url) {
  try {
    const embedUrl = new URL(url)
    embedUrl.hostname = "embed.music.apple.com"
    embedUrl.searchParams.delete("uo")
    return embedUrl.toString()
  } catch {
    return null
  }
}

export default function Embed({ url, embed_type }) {
  if (!url) return null

  if (embed_type === "youtube") {
    const embed = getYouTubeEmbed(url)
    if (!embed) return <LinkPreview url={url} />
    return (
      <div className="mt-3 rounded-xl overflow-hidden aspect-video bg-stone-900">
        <iframe
          src={embed.src}
          className="w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={embed.title}
        />
      </div>
    )
  }

  if (embed_type === "spotify") {
    const embedUrl = getSpotifyEmbed(url)
    if (!embedUrl) return <LinkPreview url={url} />

    const isTrack = url.includes("/track/")
    const height = isTrack ? "152" : "352"

    return (
      <div className="mt-3 rounded-xl overflow-hidden">
        <iframe
          src={embedUrl}
          width="100%"
          height={height}
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
          className="rounded-xl"
          title="Spotify"
        />
      </div>
    )
  }

  if (embed_type === "apple_music") {
    const embedUrl = getAppleMusicEmbed(url)
    if (!embedUrl) return <LinkPreview url={url} />

    return (
      <div className="mt-3 rounded-xl overflow-hidden">
        <iframe
          src={embedUrl}
          width="100%"
          height="175"
          frameBorder="0"
          allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
          loading="lazy"
          className="rounded-xl bg-stone-900"
          title="Apple Music"
        />
      </div>
    )
  }

  return <LinkPreview url={url} />
}

function LinkPreview({ url }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="mt-3 flex items-center gap-2 text-sm text-stone-400 hover:text-stone-200 transition-colors"
    >
      <span className="text-stone-600">↗</span>
      <span className="truncate">{url}</span>
    </a>
  )
}
